import React from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
  onClick?: () => void;
}

const PayOther: React.FC<IProps> = ({ onClick }) => {
  return (
    <div className='checkout-pay-other' data-cypid='checkoutPayOrder' onClick={onClick}>
      {i18n.t('pay.payChangeOther')}
      <Icon name='chevron-right' />
    </div>
  )
}

export default observer(PayOther)
